








































import { computed, defineComponent, PropType } from "@vue/composition-api";
import { MessageThreadUser } from "./types";
import { unixTimeMSToDateOrTimeStr } from "@/helpers/date-helper";

export default defineComponent({
  name: "ThreadUser",
  emits: ["click"],
  props: {
    user: {
      type: Object as PropType<MessageThreadUser>,
      required: true
    }
  },
  setup(props, { emit }) {
    const isShowUnreadCount = computed(() => {
      return props.user.unreadCommentCount > 0;
    });
    const isShowIdentifierSecondary = computed(() => {
      return props.user.name !== undefined;
    });
    const primaryIdentifier = computed(() => {
      if (isShowIdentifierSecondary.value) {
        return props.user.name;
      }
      return props.user.uniqueId;
    });

    // 最後のメッセージが今より将来かどうか判定するcomputedを作成
    const isReservationLastMessage = computed(() => {
      return props.user.lastMessageTimestampMs > Date.now();
    });

    const handleClickedThreadUser = () => {
      emit("click", props.user);
    };

    return {
      unixTimeMSToDateOrTimeStr,
      primaryIdentifier,
      isShowUnreadCount,
      isShowIdentifierSecondary,
      isReservationLastMessage,
      handleClickedThreadUser
    };
  }
});
